import insertTextNodes from './insertTextNodes';

export default (params) => {
  const { editor, focusParentBlock, incomingBlock, index } = params;

  // focus block is empty bullet
  if (!focusParentBlock.text) {
    // insert text nodes iteratively
    insertTextNodes(incomingBlock, editor);

    return true;
  }

  /**
   * focus block is not empty bullet
   * & focus is at beginning or end
   * & incoming block is first fragment
   */
  if (index === 0) {
    // insert text nodes iteratively
    insertTextNodes(incomingBlock, editor);

    return true;
  }

  /**
   * focus block is not empty bullet
   * & focus is in between
   */
  editor.splitBlock(2).insertText(incomingBlock.text);

  return true;
};
